import type { AgentPageScope } from './page-task-protocol';

export const AGENT_PAGE_EXCLUDE =
  '[data-agent-page-exclude],[data-agent-chat],[data-agent-sensitive],[data-message-id],script,style,noscript,input,textarea,[contenteditable="true"]';
const FORM = '[data-agent-form],[data-account-form],[role="dialog"],[role="alertdialog"],form';

/** 通用页面查询只读当前可见文本；草稿、密码、聊天正文与隐藏内容不进入模型上下文。 */
export function readAgentPageContent(
  scope: AgentPageScope,
  root?: Element,
  maxChars = 16000,
): { text: string; truncated: boolean } {
  if (typeof document === 'undefined' || !document.body) return { text: '', truncated: false };
  const walker = document.createTreeWalker(root ?? document.body, NodeFilter.SHOW_TEXT);
  const lines: string[] = [];
  let remaining = maxChars;
  let visited = 0;
  let node: Node | null;
  while ((node = walker.nextNode())) {
    if (++visited > 12000) return { text: lines.join('\n'), truncated: true };
    const element = node.parentElement;
    const text = node.textContent?.replace(/\s+/g, ' ').trim();
    if (
      !element ||
      !text ||
      element.closest(AGENT_PAGE_EXCLUDE) ||
      element.closest('[hidden],[inert],[aria-hidden="true"]') ||
      (scope === 'form' && !element.closest(FORM))
    )
      continue;
    const rect = element.getBoundingClientRect();
    if (
      !element.getClientRects().length ||
      rect.bottom <= 0 ||
      rect.right <= 0 ||
      rect.top >= window.innerHeight ||
      rect.left >= window.innerWidth
    )
      continue;
    let visible = true;
    for (let parent: HTMLElement | null = element; parent; parent = parent.parentElement) {
      const style = getComputedStyle(parent);
      if (style.visibility === 'hidden' || style.display === 'none' || style.opacity === '0') {
        visible = false;
        break;
      }
      if (parent !== element && /(auto|scroll|hidden|clip)/.test(style.overflowY)) {
        const bounds = parent.getBoundingClientRect();
        if (rect.bottom <= bounds.top || rect.top >= bounds.bottom) {
          visible = false;
          break;
        }
      }
    }
    if (!visible) continue;
    const target = element
      .closest('[data-fett-page-target]')
      ?.getAttribute('data-fett-page-target');
    const line = `${target ? `[${target}] ` : ''}${text}`;
    if (line.length > remaining) return { text: lines.join('\n'), truncated: true };
    lines.push(line);
    remaining -= line.length + 1;
  }
  return { text: lines.join('\n'), truncated: false };
}
